import request from '../../../shared/request'

export function getLeadContacts(lead_id) {
  return request(`/lead/contacts/${lead_id}/`)
}

export function getAllLeadContacts(lead_id) {
  return request(`/lead/contacts/`)
}

export function addLeadContact(payload) {
  return request(`/lead/contacts/${payload.lead_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function removeLeadContact(payload) {
  return request(`/lead/contacts/${payload.contact_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function createContact(payload) {
  return request(`/contacts/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateLeadContact(payload) {
  return request(`/lead/contacts/${payload.lead_contact_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteLeadContact(payload) {
  return request(`/lead/contacts/${payload.lead_contact_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateLeadPrimaryContact(payload) {
  return request(`/lead/contacts/${payload.leadId}/primary`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/lead/contacts.js